// CRM Analytics Tracker - sends behavioral events to CRM backend
export const CRMTracker = async (eventType, metadata = {}) => {
  try {
    const storeId = process.env.REACT_APP_CRM_STORE_ID;
    const apiUrl = process.env.REACT_APP_CRM_API_URL;
    
    if (!storeId || !apiUrl) {
      console.warn('CRMTracker: Missing storeId or apiUrl in environment variables.');
      return;
    }

    // Initialize or fetch tracking IDs
    let visitorId = localStorage.getItem('crm_visitor_id');
    if (!visitorId) {
      visitorId = 'visitor_' + Math.random().toString(36).substring(2, 15);
      localStorage.setItem('crm_visitor_id', visitorId);
    }

    let sessionId = sessionStorage.getItem('crm_session_id');
    if (!sessionId) {
      sessionId = 'sess_' + Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem('crm_session_id', sessionId);
    }

    // Get customer identity if logged in
    let customerName = null;
    let customerEmail = null;
    let customerPhone = null;
    let customerAddress = null;
    const isLoggedIn = localStorage.getItem('nattu_customer_login') === 'true';
    if (isLoggedIn) {
      const customerInfoStr = localStorage.getItem('nattu_customer_info');
      if (customerInfoStr) {
        try {
          const customerInfo = JSON.parse(customerInfoStr);
          customerName = customerInfo.name || null;
          customerEmail = customerInfo.email || null;
          customerPhone = customerInfo.phone || null;
        } catch (e) { /* ignore parse errors */ }
      }

      // If details are missing, fetch dynamically from profile API
      if (!customerName && !customerEmail) {
        try {
          const token = localStorage.getItem("nattu_customer_token");
          if (token) {
            const apiBaseUrl = process.env.REACT_APP_API_WEB_URL || "http://localhost:8000/api/v1/";
            const response = await fetch(`${apiBaseUrl}myaccount.php?action=getprofile`, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });
            if (response.ok) {
              const res = await response.json();
              if (res?.status === 200 && res?.success && res?.data) {
                customerName = res.data.name || res.data.customer_name || null;
                customerEmail = res.data.email || res.data.customer_email || null;
                customerPhone = res.data.phone || res.data.customer_phone || null;
                localStorage.setItem('nattu_customer_info', JSON.stringify({
                  name: customerName,
                  email: customerEmail,
                  phone: customerPhone
                }));
              }
            }
          }
        } catch (err) {
          console.error("CRMTracker: Failed to fetch profile dynamically", err);
        }
      }

      // Get customer address if logged in
      const cachedAddressStr = localStorage.getItem('nattu_customer_address');
      if (cachedAddressStr) {
        try {
          customerAddress = JSON.parse(cachedAddressStr);
        } catch (e) { /* ignore parse errors */ }
      }

      if (!customerAddress) {
        try {
          const token = localStorage.getItem("nattu_customer_token");
          if (token) {
            const apiBaseUrl = process.env.REACT_APP_API_WEB_URL || "http://localhost:8000/api/v1/";
            const response = await fetch(`${apiBaseUrl}myaccount.php?action=addresslist&page=1&limit=10`, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });
            if (response.ok) {
              const res = await response.json();
              if (res?.status === 200 && res?.success && res?.data) {
                const addresses = res.data.data || [];
                const defaultAddress = addresses.find(addr => addr.set_default != 0) || addresses[0];
                if (defaultAddress) {
                  customerAddress = {
                    country: defaultAddress.country || 'India',
                    city: defaultAddress.city || 'Unknown',
                    state: defaultAddress.state || '',
                    pincode: defaultAddress.pincode || ''
                  };
                  localStorage.setItem('nattu_customer_address', JSON.stringify(customerAddress));
                }
              }
            }
          }
        } catch (err) {
          console.error("CRMTracker: Failed to fetch address list dynamically", err);
        }
      }
    } else {
      localStorage.removeItem('nattu_customer_address');
    }

    // Detect browser
    const ua = navigator.userAgent || '';
    let browser = 'Unknown';
    if (ua.includes('Chrome') && !ua.includes('Edg')) browser = 'Chrome';
    else if (ua.includes('Safari') && !ua.includes('Chrome')) browser = 'Safari';
    else if (ua.includes('Firefox')) browser = 'Firefox';
    else if (ua.includes('Edg')) browser = 'Edge';

    // Detect device type
    let device = 'desktop';
    if (window.innerWidth < 768) device = 'mobile';
    else if (window.innerWidth < 1024) device = 'tablet';

    const payload = {
      storeId,
      sessionId,
      visitorId,
      customerName,
      customerEmail,
      customerPhone,
      eventType,
      metadata,
      device,
      browser,
      location: metadata._location || customerAddress || { country: 'India', city: 'Unknown' }
    };

    // Remove internal _location field from metadata
    if (metadata._location) {
      const { _location, ...cleanMetadata } = metadata;
      payload.metadata = cleanMetadata;
    }

    console.log(`CRMTracker: Sending '${eventType}' event to ${apiUrl}`);

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      const data = await response.json();
      console.log(`CRMTracker: ✅ Event '${eventType}' sent successfully`, data);
    } else {
      console.error('CRMTracker: ❌ Failed to send event', response.status, await response.text());
    }
  } catch (error) {
    console.error('CRMTracker: Error tracking event', error);
  }
};
